export const BASE_URL = 'https://goose-track-students.b.goit.study/';
